import Image from "next/image";
// import MobileFilter from "@assets/mobile_filter.png";
import MobileFilter from "@assets/mobile_filter_two.png";

const Filter = (props) => {
  return <Image src={MobileFilter} height={23} width={25} />;
};

export default Filter;
